var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrusted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M21.327 35.99h-.41c-4.733 0-9.465.011-14.197 0-3.265 0-5.942-2.2-6.587-5.387a6.58 6.58 0 0 1-.122-1.322C0 21.76 0 14.23 0 6.709 0 2.966 2.944.011 6.676.011c5.32-.01 10.641-.01 15.962 0 3.744.011 6.676 2.944 6.687 6.687.011 3 0 5.999 0 8.998 0 .122-.01.244-.022.377-.833 0-1.655-.066-2.466.012-3.899.377-7.342 3.61-8.009 7.486-.533 3.055.245 5.743 2.288 8.065.09.11.2.255.2.389.023 1.3.011 2.599.011 3.965ZM14.663 6.665H6.787c-.666 0-1.144.3-1.366.833-.356.922.31 1.833 1.355 1.833H22.56c.622 0 1.078-.256 1.333-.822.4-.9-.277-1.844-1.31-1.844h-7.92Zm-2.377 6.665H6.709c-.788 0-1.366.577-1.377 1.322a1.33 1.33 0 0 0 1.355 1.344c3.743.01 7.498.01 11.241-.011.267 0 .578-.123.8-.278.467-.311.633-.922.467-1.444-.19-.567-.667-.933-1.289-.933h-5.62Zm-1.989 6.665H6.798c-.877 0-1.477.555-1.466 1.355.011.766.61 1.31 1.466 1.31h6.954c.866 0 1.488-.577 1.477-1.355-.011-.766-.622-1.31-1.477-1.31h-3.455Zm-.167 9.33h3.333c.844 0 1.444-.566 1.444-1.333 0-.766-.611-1.322-1.455-1.333H6.798c-.855 0-1.455.545-1.466 1.311-.011.8.6 1.355 1.466 1.355 1.11.011 2.222 0 3.332 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M34.657 25.349c-.011 3.677-3.01 6.653-6.698 6.642a6.656 6.656 0 0 1-6.632-6.698c.011-3.654 3.01-6.631 6.676-6.62a6.656 6.656 0 0 1 6.654 6.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M31.98 33.768c0 1.711.044 3.377-.011 5.044-.034.977-1.167 1.5-2.022.966a34.782 34.782 0 0 1-1.7-1.133c-.188-.133-.322-.133-.51 0-.522.366-1.056.71-1.589 1.066-.466.311-.944.389-1.444.111-.5-.266-.71-.71-.71-1.266v-4.799c2.676 1.2 5.32 1.2 7.986.011Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.056,
    x2: -3.076,
    y1: 5.847,
    y2: 21.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 31.805,
    x2: 21.333,
    y1: 20.835,
    y2: 28.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 30.285,
    x2: 25.156,
    y1: 34.77,
    y2: 39.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34.657v40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusted);
export default __webpack_public_path__ + "static/media/Trusted.fdd7c1ff24ff7a78439b2a6640b355da.svg";
export { ForwardRef as ReactComponent };